import { GetterTree } from 'vuex';
import { WidgetState } from './types';
import { RootState } from '../types';
import { IFile, IProperty, SUPPORTED_CURRENCIES } from '@resclick/data-access';
import { i18n } from '@/i18n';

export const getters: GetterTree<WidgetState, RootState> = {
  propertyId: (state) => (state.settings.property as IProperty)?.id,
  property: (state) => state.settings.property as IProperty,
  widgetId: (state) => state.settings.id,
  additionalProducts: (state) => state.settings.additionalProducts || [],
  policies: (state) => state.settings.policies,

  logo: (state) => {
    const { logo = {} as IFile } = state.settings;
    if (logo.sizes?.small) {
      return process.env.VUE_APP_CDN_URL + '/' + logo.sizes.small;
    }
    return '';
  },
  amenities: (state) => (state.settings?.property as IProperty)?.amenities || {},
  steps: (state) => {
    const { additionalProducts = [] } = state.settings || {};
    const results = [
      {
        id: 0,
        label: i18n.t('GENERAL.ROOM_SELECTION'),
        icon: 'mdi-bed',
      },
    ];

    if (additionalProducts.length) {
      results.push({
        id: 1,
        label: i18n.t('GENERAL.ADDITIONAL_SERVICES'),
        icon: 'mdi-package-variant-closed',
      });
    }

    return [
      ...results,
      {
        id: 2,
        label: i18n.t('GENERAL.CUSTOMER_AND_INVOICE'),
        icon: 'mdi-account',
      },
      {
        id: 3,
        label: i18n.t('GENERAL.PAYMENT'),
        icon: 'mdi-credit-card',
      },
    ];
  },
  stepMeta: (state, getter) => {
    const { steps = [] } = getter;

    return (step: number) => {
      const currentIndex = steps.findIndex((s: { id: number }) => s.id === step);
      return {
        prev: steps[currentIndex - 1]?.id || 0,
        current: step,
        next: steps[currentIndex + 1]?.id || 1000,
      };
    };
  },
  market: (state) => {
    return state.settings.market || {};
  },
  marketLocales: (state, getters) => {
    return getters.market.languages;
  },
  marketCurrency: (state, getters) => {
    const supportedCurrencies = SUPPORTED_CURRENCIES.map((currency) => currency.code);
    return supportedCurrencies.includes(getters.market.currency) ? getters.market.currency : 'EUR';
  },
  marketCountryId: (state, getters) => {
    return getters.market.id;
  },
};
